import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import 'rxjs/add/operator/map';
@Injectable()
export class LoginService {
   host:string;
  constructor(private http:HttpClient) {

    if(location.hostname=='localhost'){
      this.host="http://localhost/playit-admin/API/public/api/v1/";
    }
    else {
      this.host="http://www.api.playit.mobi/api/v1/";
    }
    this.host="http://www.api.playit.mobi/api/v1/";

   }
  //call api to login
  login(data){
    return this.http.post(`${this.host}Admin/login`,data).map(result=>result);
  }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/playitadmin_frontend/src/app/Services/login.service.ts